import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as IconAssets from './IconAssets.js';

var IconSVGFile = props => {
  var _IconAssets;
  var attributes = {};
  if (props.className) {
    attributes.className = props.className;
  }
  var prefix = '';
  if (props.theme && props.theme.toLowerCase() === 'bankwest') {
    prefix = 'BW';
  }

  // based on the version of react-scripts, get the image src
  // @ts-ignore
  var imgSrc = IconAssets[prefix + props.symbol];

  // @ts-ignore
  if ((_IconAssets = IconAssets[prefix + props.symbol]) !== null && _IconAssets !== void 0 && _IconAssets.default) {
    var _IconAssets2;
    // @ts-ignore
    imgSrc = (_IconAssets2 = IconAssets[prefix + props.symbol]) === null || _IconAssets2 === void 0 ? void 0 : _IconAssets2.default;
  }
  return /*#__PURE__*/React.createElement("img", _extends({
    src: imgSrc,
    alt: "",
    "aria-hidden": true
  }, attributes));
};
IconSVGFile.propTypes = {
  className: PropTypes.string,
  symbol: PropTypes.oneOf(Object.keys(IconAssets).concat(Object.keys(IconAssets).map(name => name.replace(/BW/g, '')))).isRequired,
  theme: PropTypes.string
};

export { IconSVGFile };
